import { RootState } from "../../../system/redux/store/community-finder-redux-store";

export const selectSelectedFacets = (state: RootState) =>
	state?.facets?.selectedFacets;
